// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ow9x","footer":"ModalUpdate_footer__2gR5S"};